import React from "react";
import {COLUMN_CELL_INVALID_CONTENT} from "../../../columns";
import {DashboardCell} from "./DashboardCell";
import {METRICS_WITH_POTENTIAL_EMPTY_VALUES, EMPTY_METRIC_VALUE_TOOLTIP_KEYS} from "../../../metrics";
import {FaIcon} from "../../../../FaIcon";
import {withTranslation} from "react-i18next";

class DashboardSingleValueCellClass extends DashboardCell {
    isEmptyValue() {
        const value = this.props.value;
        const columnData = this.props.columnData;
        
        // Verificar el valor formateado
        const isFormattedValueEmpty = value === null || value === undefined || value === "---" || value === "";
        
        // También verificar main_period_value si está disponible
        const isMainPeriodValueEmpty = columnData && (
            columnData.main_period_value === null || 
            columnData.main_period_value === undefined
        );
        
        return isFormattedValueEmpty && (columnData ? isMainPeriodValueEmpty : true);
    }

    shouldShowEmptyDataIcon() {
        if (!this.isEmptyValue()) {
            return false;
        }

        const metricName = this.props.metricName;
        const columnData = this.props.columnData;
        
        // Verificar si la métrica está en el array de métricas que pueden venir vacías
        if (!metricName || !METRICS_WITH_POTENTIAL_EMPTY_VALUES.includes(metricName)) {
            return false;
        }

        // Verificar que columnData tenga metric_name y coincida
        if (columnData && columnData.metric_name && columnData.metric_name === metricName) {
            return true;
        }

        return false;
    }

    getEmptyMetricTooltipKey() {
        const metricName = this.props.metricName;
        return EMPTY_METRIC_VALUE_TOOLTIP_KEYS[metricName] || 'dashboard.empty_metric_value_tooltip.default';
    }

    renderEmptyDataIcon() {
        if (!this.shouldShowEmptyDataIcon()) {
            return null;
        }

        const {t} = this.props;
        const tooltipKey = this.getEmptyMetricTooltipKey();
        const tooltipText = t(tooltipKey);
        return (
            <div className="info-icon-container me-2">
                <FaIcon iconName="info-circle"/>
                <div className="warning-tooltip">
                    <div className="warning-tooltip-body">
                        <p className="warning-tooltip-text" dangerouslySetInnerHTML={{__html: tooltipText}}></p>
                    </div>
                </div>
            </div>
        );
    }

    renderContent() {
        const itemsToRender = [];
        const warningRendered = this.renderWarningIfNecessary();
        if(warningRendered !== null) {
            itemsToRender.push(warningRendered);
        }
        const liveMetaRendered = this.renderLiveMetaIfNecessary();
        if(liveMetaRendered !== null) {
            itemsToRender.push(liveMetaRendered);
        }

        if(this.props.value === COLUMN_CELL_INVALID_CONTENT && itemsToRender.length > 0){
            return itemsToRender;
        }

        // Si debe mostrar el icono de dato vacío, mostrar solo el icono
        if (this.shouldShowEmptyDataIcon()) {
            itemsToRender.push(this.renderEmptyDataIcon());
            return itemsToRender;
        }

        itemsToRender.push(this.props.value);
        return itemsToRender;
    }

    render() {
        return <td className={`single-data ${this.processingCssClasses()}`}>{this.renderContent()}</td>;
    }
}

export const DashboardSingleValueCell = withTranslation()(DashboardSingleValueCellClass);
